import {LanguageSwitcherConfiguration} from "../../../app-bootstrap/config-interfaces/b2c-startup.configurations";
import {StandardThemeCustomizer} from "../../../services/theme/standard-theme-customizer";

export class MrGreenThemeCustomizer extends StandardThemeCustomizer {
    getHomePageTopBannerHeight(): string {
        if (this.services.mediaQuery.mAndBelow) {
            return "20rem";
        }

        return "16rem";
    }

    getLanguageSwitcherConfigForTestEnvironments(): LanguageSwitcherConfiguration {
        return {
            languages: [
                {
                    "title": "简体中文",
                    "url": "https://cns.mrgreen.com/"
                },
                {
                    "title": "Deutsch",
                    "url": "https://de.mrgreen.com/"
                },
                {
                    "title": "Español",
                    "url": "https://es.mrgreen.com/"
                },
                {
                    "title": "Français",
                    "url": "https://fr.mrgreen.com/"
                },
                {
                    "title": "日本語",
                    "url": "https://jp.mrgreen.com/"
                },
                {
                    "title": "Русский",
                    "url": "https://ru.mrgreen.com/"
                },
                {
                    "title": "ภาษาไทย",
                    "url": "https://th.mrgreen.com/"
                },
                {
                    "title": "Português",
                    "url": "https://br.mrgreen.com/"
                },
                {
                    "title": "العربية",
                    "url": "https://ar.mrgreen.com/"
                }
            ],
            countries: [],
            languageSettings: {
                "title": "Choose your language:",
                "current": "English"
            },
            countrySettings: {
                "title": "Or choose your country:",
                "current": ""
            }
        };
    }
}
